import React, { useCallback } from 'react';
import { AiOutlineLogout } from 'react-icons/ai';
import { IoIosArrowDropleft } from 'react-icons/io';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../providers/auth-provider';
import LogoLoader from '../reports/shared/results/logo-loader';

function ClientHeader() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { userDisplayName, slug } = useAuth();
  const renderTooltip = <Tooltip id="button-tooltip">Logout</Tooltip>;
  const backTooltip = <Tooltip id="button-tooltip">Back</Tooltip>;

  const doLogout = () => {
    auth.logout();
  };
  const goBack = () => navigate(-1);

  const displayBackButton = useCallback(() => {
    return !(location.pathname === '/' || location.pathname.indexOf('reports-by-token') > 0);
  }, [location]);

  const displayLogoutButton = useCallback(() => {
    return !(location.pathname.indexOf('reports-by-token') > 0);
  }, [location]);

  return (
    <div className="container-fluid bg-white">
      <div className="row bg-dark flex-nowrap">
        <div className="col flex-grow-1">
          <LogoLoader
            slug={slug}
            fileName={'banner-logo.png'}
            className="d-sm-block my-2 pt-2 pb-2 client-header-logo"
            style={{ height: '64px' }}
          />
        </div>
        <div className="col flex-nowrap text-white client-header-web">
          <div className="row justify-content-end align-content-center h-100 pe-3">{userDisplayName}</div>
        </div>
        {displayBackButton() && (
          <div className="col flex-grow-0 align-content-between text-end text-white client-header-web">
            <div className="row h-100">
              <OverlayTrigger placement="left" overlay={backTooltip}>
                <Button className="text-white border-0" style={{ backgroundColor: '#282727' }} onClick={goBack}>
                  <IoIosArrowDropleft size="1.65em" />
                </Button>
              </OverlayTrigger>
            </div>
          </div>
        )}
        {displayLogoutButton() && (
          <div className="col flex-grow-0 align-content-between text-end text-white client-header-web">
            <div className="row h-100">
              <OverlayTrigger placement="left" overlay={renderTooltip}>
                <Button className="text-white border-0" style={{ backgroundColor: '#282727' }} onClick={doLogout}>
                  <AiOutlineLogout size="1.5em" />
                </Button>
              </OverlayTrigger>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ClientHeader;
